import type { EventEmitter } from '@widgets/shared/types'

type EventCode = string
type ListenerId = string
type ListenerCallback<P = any> = (payload: P) => void

interface Listener<P = any> {
  id: ListenerId
  eventCode: EventCode
  callback: ListenerCallback<P>
}

export default class EventEmitterService implements EventEmitter {
  protected listeners: Listener[] = []

  public on<P>(eventCode: EventCode, callback: ListenerCallback<P>): ListenerId {
    const id = (Date.now().toString() + Math.random().toString()) as ListenerId

    this.listeners.push({
      id,
      eventCode,
      callback,
    })
    return id
  }

  public remove(id: ListenerId) {
    const index = this.listeners.findIndex((listener) => listener.id === id)
    if (index === -1) {
      return
    }
    this.listeners.slice(index, 1)
  }

  public emit(eventCode: EventCode, payload?: any) {
    this.listeners.forEach((listener) => {
      if (listener.eventCode !== eventCode) {
        return
      }
      listener.callback(payload)
    })
  }
}

export const eventEmitterService = new EventEmitterService()
